import { Autocomplete, Box, Paper, TextField, ThemeProvider, createTheme, useTheme } from '@mui/material';
import { type FormikErrors } from 'formik';
import { type MovieFormikValues, type Option } from '#components/Filters/types.ts';

export type KeywordMultiSelectDropdownProps = {
  ariaLabelledBy: string;
  name: string;
  options: Option[];
  setFieldValue: (
    field: string,
    value: any, // eslint-disable-line @typescript-eslint/no-explicit-any
    shouldValidate?: boolean,
  ) => Promise<FormikErrors<MovieFormikValues>> | Promise<void>;
  value: Option[];
};

export const KeywordMultiSelectDropdown = ({
  ariaLabelledBy,
  name,
  options,
  setFieldValue,
  value,
}: KeywordMultiSelectDropdownProps) => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={createTheme({ ...theme, palette: { mode: 'dark' } })}>
      <Autocomplete
        aria-labelledby={ariaLabelledBy}
        autoComplete
        clearIcon=""
        filterSelectedOptions
        getOptionLabel={option => option.name}
        includeInputInList
        multiple
        noOptionsText=""
        onChange={(_e, option) => {
          void setFieldValue(name, option);
        }}
        options={options}
        renderInput={params => <TextField {...params} fullWidth hiddenLabel placeholder="Enter name" />}
        renderOption={(props, renderOpts) => (
          <Box component="li" {...props} key={renderOpts.id}>
            {renderOpts.name}
          </Box>
        )}
        slots={{
          paper: params => <Paper {...params} sx={{ backgroundColor: '#222' }} />,
        }}
        value={value}
      />
    </ThemeProvider>
  );
};
